export class GlobalSettings {
    static Settings = {
        Keys : ['cSkQTVBREN'],
        Server: process.env.NEXT_PUBLIC_SERVER_URL,//'http://client.dev.giaophanphucuong.com',
        Server_New: process.env.NEXT_PUBLIC_SERVER_NEW_URL,//'http://client.dev.giaophanphucuong.com',
        Diocese: process.env.NEXT_PUBLIC_DIOCESE_CLIENT_API_URL || 'https://diocese-client-api.cmate.vn',
        DioceseID: process.env.DIOCESE_ID || 'c82cf36b-db03-4fcc-900a-ad0e81b59864',
        WebServer: process.env.NEXT_PUBLIC_WEBSERVER_URL,
        ServerDev: 'http://client.dev.giaophanphucuong.com',
        // ServerClient: 'http://client.dev.giaophanphucuong.com',
        YouTube: {
            APIKey: process.env.NEXT_PUBLIC_API_KEY_YOUTUBE
        },
        Grid: {
            pageSize: 10,
            listPageSize: 20,
            skip: 0,
            filter: ''
        },
        delayTimer: {
            valueChanges: 500
        },
        DateTime: {
            dateTimePattern: 'MMM DD YYYY, h:mm:ss A',
            dateTimePattern1: 'MM/DD/YYYY, h:mm A',
            dateTimePattern2: 'MMM DD, YYYY h:mm:ss A',
            dateTimePattern3: 'MMM DD YYYY, h:mm:ss A (UTCZ)',
            dateTimePattern4: 'dddd YYYY-MM-DD hh:mm:ss',
            shortDatePattern: 'MMM DD YYYY',
            shortDatePattern1: 'MMMM DD, YYYY',
            shortDatePattern2: 'MMMM DD YYYY',
            shortDatePattern3: 'MMMM DD',
            shortDatePattern4: 'MMM DD',
            shortDatePattern5: 'MM/DD/YYYY',
            timePattern: 'h:mm:ss A',
            timePatternAM: 'h:mm A',
            timePatternAM2: 'hh:mm a'
        },
        Version: '1.0.0'
    };
}
